export const fmtNum = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0));

export const fmtEur = (n) =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);

export const fmtMwhc = (kwhc) => `${fmtNum((Number(kwhc) || 0) / 1000)} MWhc`;

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "-";
  }
};

export const SECTOR_META = {
  BAR: { label: "Résidentiel", color: "#2563EB", badge: "bg-blue-100 text-blue-700 border-blue-200" },
  BAT: { label: "Tertiaire", color: "#0D9488", badge: "bg-teal-100 text-teal-700 border-teal-200" },
  IND: { label: "Industrie", color: "#D97706", badge: "bg-amber-100 text-amber-700 border-amber-200" },
  AGRI: { label: "Agricole", color: "#65A30D", badge: "bg-lime-100 text-lime-700 border-lime-200" },
  RES: { label: "Réseau de chaleur", color: "#DC2626", badge: "bg-red-100 text-red-700 border-red-200" },
};

export const SECTOR_ACTIVITY_OPTIONS = [
  { value: "bureaux_enseignement_commerces", label: "Bureaux / Enseignement / Commerces" },
  { value: "hotellerie_restauration", label: "Hôtellerie - Restauration" },
  { value: "sante", label: "Santé" },
  { value: "autres", label: "Autres secteurs" },
];
